module.exports = __webpack_public_path__ + "img/36.21675e1c.svg";